import { render, staticRenderFns } from "./Resolution.vue?vue&type=template&id=2c754b58&"
import script from "./Resolution.vue?vue&type=script&lang=js&"
export * from "./Resolution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports